import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AuthService } from '@services/auth.service';
import { CaricamentoService } from '@services/caricamento.service';
import { NavigazioneService } from '@services/navigazione.service';
import { iniziali } from '@services/iniziali.util';
import { BreadcrumbComponent } from '@shared/breadcrumb/breadcrumb.component';
import { ToggleThemeComponent } from '@shared/toggle-theme/toggle-theme.component';

/**
 * Barra in alto: dove ti trovi a sinistra, chi sei a destra.
 *
 * Prima il logout era l'ultima voce del menu laterale e l'utente collegato non
 * compariva da nessuna parte, se non nel "Benvenuto" della dashboard.
 */
@Component({
  selector: 'app-topbar',
  standalone: true,
  imports: [
    RouterLink,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatProgressBarModule,
    MatTooltipModule,
    BreadcrumbComponent,
    ToggleThemeComponent,
  ],
  templateUrl: './topbar.component.html',
})
export class TopbarComponent {
  readonly authService = inject(AuthService);
  readonly navigazione = inject(NavigazioneService);
  readonly caricamento = inject(CaricamentoService);

  get nome(): string {
    return this.authService.user?.blogger ?? '';
  }

  get iniziali(): string {
    return iniziali(this.nome);
  }
}
